/**
 * AddContentSetsCtrl controller
 */
import { CONTENT_TYPES_SETS_SHORT } from '../../app/core/constants'

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

// controller mixins
AddContentSetsCtrl.mixes = [
  'openPopupCtrlMixin'
]

/**
 * AddContentSetsCtrl controller
 *
 * @class AddContentSetsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:openPopupCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddContentSetsCtrl
 */
/* @ngInject */
export default function AddContentSetsCtrl ($uibModal, $uibModalInstance, $location, $scope, Subscription, ChannelSet, ShowSet, VODSet, LiveEventSet, type, assignedSets,
  networkId, subscription, addons, hasCSintersection) {
  var vm = this
  vm.networkId = networkId
  vm.type = type
  vm.url2 = ''
  vm.contentSets = { assigned: { sets: [] }, available: { sets: [] } }
  vm.contentSets.assigned.sets = angular.copy(assignedSets)

  vm.subscription = subscription
  vm.availableFilter = ''
  vm.assignedFilter = ''
  vm.isFormDisabled = true
  vm.content_types_sets = CONTENT_TYPES_SETS_SHORT

  vm.hasCSintersection = hasCSintersection
  /**
   * Table state for pageable request
   *
   * @memberof mwApp/packages.controller:AddContentSets
   * Ctrl
   */
  vm.initTableState = {
    page: 0,
    count: 25,
    name: '',
    last: false
  }
  vm.tableState = angular.copy(vm.initTableState)

  vm.contentTypes = {
    channel: 'Channel',
    tv_show: 'TV Show',
    live_event: 'Live Event',
    vod: 'VOD',
    SEASON: 'Season',
    EPISODE: 'Episode'
  }

  vm.getSets = function (tableState) {
    const params = { networkId, subscriptionId: subscription.id || 0 }
    const url2s = `organizations/${networkId}/contentSets/`
    if (type === 'vodSets') {
      vm.label = 'VOD'
      vm.url2 = url2s + 'vod/'
      return VODSet.loadContentSets(params, tableState)
    }
    if (type === 'tvShowSets') {
      vm.label = 'TV Show'
      vm.url2 = url2s + 'show/'
      return ShowSet.loadContentSets(params, tableState)
    }
    if (type === 'channelSets') {
      vm.label = 'Channel'
      vm.url2 = url2s + 'channel/'
      return ChannelSet.loadContentSets(params, tableState)
    }
    if (type === 'liveEventSets') {
      vm.label = 'Live Event'
      vm.url2 = url2s + 'liveEvent/'
      return LiveEventSet.loadContentSets(params, tableState)
    }
  }

  vm.contentSets.available.sets = []

  vm.getInitSets = function () {
    vm.getSets(vm.tableState).then((result) => {
      vm.contentSets.available.sets.push(...result.content.filter(set =>
        !(vm.contentSets.assigned.sets.find(s => s.id === set.id) || addons.find(s => s.id === set.id))))
      vm.tableState.last = result.last
      if (!result.last && vm.contentSets.available.sets.length < result.size) {
        vm.tableState.page++
        vm.getInitSets(vm.tableState)
      }
    })
  }

  vm.getInitSets()

  vm.searchAvailableSets = function () {
    vm.tableState = angular.copy(vm.initTableState)
    vm.getSets({ ...vm.tableState, q: vm.availableFilter }).then((result) => {
      vm.contentSets.available.sets = result.content || []
      vm.contentSets.available.sets = vm.contentSets.available.sets.filter(set => {
        return !(vm.contentSets.assigned.sets.find(s => s.id === set.id) || addons.find(s => s.id === set.id))
      })
      vm.tableState.last = result.last
    })
  }

  /**
   * Handler for scroll event of Available select list
   *
   * @memberof mwApp/packages.controller:AddContentSetsCtrl
   * @param event
   */
  vm.$timerScroll = 0
  vm.contentCallbackAvailableScroll = (event) => {
    const {
      page,
      last
    } = vm.tableState
    if (!last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerScroll)
      vm.$timerScroll = window.setTimeout(() => {
        vm.getSets({ ...vm.tableState, page: page + 1 })
          .then((result) => {
            vm.tableState.last = result.last
            vm.contentSets.available.sets = vm.contentSets.available.sets.concat(result.content)
            vm.contentSets.available.sets = vm.contentSets.available.sets.filter(set => {
              return !(vm.contentSets.assigned.sets.find(s => s.id === set.id) || addons.find(s => s.id === set.id))
            })
            vm.tableState.page++
          })
      }, 700)
    }
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    list.sets = list.sets
      .slice(0, index)
      .concat(items)
      .concat(list.sets.slice(index))
    items.forEach(item => { item.selected = !item.selected })
    vm.isFormDisabled = false
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    link.selected = true
    return list.filter(link => link.selected)
  }
  /**
   * Delete show from showSet
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   */
  vm.deleteSet = function (channel) {
    event.preventDefault()
    channel.selected = false
    channel.conflicts = []
    vm.contentSets.assigned.sets = vm.contentSets.assigned.sets.filter(ch => ch.id !== channel.id)
    vm.contentSets.available.sets.push(channel)
    vm.checkIntersection(true)
    vm.isFormDisabled = false
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => {
      item.selected = false
      item.conflicts = []
    })
    list.dragging = false
    vm.checkIntersection()
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list.sets = list.sets.filter(item => !item.selected)
  }

  /**
   * Create or edit season, and close modal window afterwards
   *
   * @memberof mwApp/addContentSets.controller:AddContentSetsCtrl
   */
  vm.submit = function () {
    $uibModalInstance.close(vm.contentSets.assigned.sets)
  }

  vm.checkIntersection = function (checkOnDelete = false) {
    if (checkOnDelete && !vm.hasCSintersection) { return }
    Subscription.checkIntersection(type, { networkId, id: subscription.id || 0 }, vm.contentSets.assigned.sets, subscription.paidContentSets[type])
      .then(data => {
        vm.hasCSintersection = data
        if (!vm.hasCSintersection && vm.openedConflict) {
          vm.closeConflicts()
        }
      })
  }

  vm.openConflicts = function (cs) {
    vm.contentSets.assigned.sets.forEach(set => { set.openConflict = false })
    event.stopPropagation()
    cs.openConflict = true
    vm.openedConflict = cs
  }

  vm.closeConflicts = function () {
    vm.openedConflict.openConflict = false
    vm.openedConflict = false
  }

  vm.openConflictsFooter = window.innerHeight > 750
  /**
   * Method for filtering sets by name
   *
   * @param {Object} contentSet
   * @memberof mwApp/packages.controller:AddAddonsCtrl
   */
  vm.filteredAssigned = (contentSet) => {
    return vm.assignedFilter.length > 0
      ? contentSet.name.includes(vm.assignedFilter)
      : true
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/addContentSets.controller:AddContentSetsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
  vm.access = {
    channelSets: 'editChannel',
    tvShowSets: 'editVodSeries',
    liveEventSets: 'editLiveEvent',
    vodSets: 'editVod'
  }
}
